module.exports = __webpack_public_path__ + "img/compact.a42f70bb.png";